import React from 'react';
import img from '../../../assets/icons/payment-logos/skrill.svg'
const Skrill = () => {
  return (
    <img src={img} alt="/" />
  );
}

export default Skrill;
